<template>
  <div>
    <h2><i class="fa fa-store-alt">&nbsp;</i><org-badge />Dashobard<small v-if="!isTowerCo() && org().shortName" class="text-info pull-right hidden-sm-and-down">{{org().name}}</small></h2>
    <tenancy-due :org-id="org().id" />
  </div>
</template>

<script>

import TenancyDue from '@/components/dashboard/property/TenancyDue'

export default {
  components: {
    TenancyDue
  }
}

</script>



// WEBPACK FOOTER //
// LandlordView.vue?587f86b0